import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { businessInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold bg-gradient-to-r from-amber-400 to-amber-600 bg-clip-text text-transparent mb-4">
              {businessInfo.name}
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              {businessInfo.tagline}
            </p>
            <p className="text-gray-400 text-sm">
              Authorized Vista Fashion Dealer
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-amber-400 transition-colors text-sm">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-amber-400 transition-colors text-sm">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-amber-400 transition-colors text-sm">Services</Link></li>
              <li><Link to="/products" className="text-gray-400 hover:text-amber-400 transition-colors text-sm">Products</Link></li>
              <li><Link to="/portfolio" className="text-gray-400 hover:text-amber-400 transition-colors text-sm">Portfolio</Link></li>
              <li><Link to="/vista-fashion" className="text-gray-400 hover:text-amber-400 transition-colors text-sm">Vista Fashion</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Our Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Interior Designing</li>
              <li>Window Blinds</li>
              <li>Curtains & Rods</li>
              <li>Wooden Flooring</li>
              <li>Wallpapers</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
                <div>
                  <a href={`tel:${businessInfo.phones[0]}`} className="text-gray-400 hover:text-amber-400 transition-colors block">
                    {businessInfo.phones[0]}
                  </a>
                  <a href={`tel:${businessInfo.phones[1]}`} className="text-gray-400 hover:text-amber-400 transition-colors block">
                    {businessInfo.phones[1]}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${businessInfo.email}`} className="text-gray-400 hover:text-amber-400 transition-colors break-all">
                  {businessInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400">{businessInfo.address}</span>
              </li>
              <li className="flex items-center space-x-2 pt-2">
                <a href={businessInfo.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-gray-400 hover:text-amber-400 transition-colors">
                  <Instagram className="w-5 h-5" />
                  <span>Follow us on Instagram</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} {businessInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
